import { AccountCircle } from "@mui/icons-material";
import { Box, CircularProgress, TextField, Tooltip } from "@mui/material";
import { NanonetsIcon } from "../svgUrls";
import "../styles/workflowMainScreen.css";
import "../styles/commonStyles.css"
import { Node } from "../types/workflow";

type WorkflowMainScreenProps = {
    userPrompts: string[];
    isGeneratingWorkflow: boolean;
    generatedWorkflow: Node[] | null;
    hasDemoRun: boolean[];
    currentInput: string;
    setCurrentInput: React.Dispatch<React.SetStateAction<string>>;
    userInput: string[];
    setUserInput: React.Dispatch<React.SetStateAction<string[]>>;
    fetchAPI: (query: string) => void;
}

const WorkflowMainScreen: React.FC<WorkflowMainScreenProps> = ({
    userPrompts,
    isGeneratingWorkflow,
    generatedWorkflow,
    hasDemoRun,
    currentInput,
    setCurrentInput,
    userInput,
    setUserInput,
    fetchAPI,
}) => {

    return <Box sx={{ display: "flex", width: "100%", height: "100%", flexDirection: "column", flex: 1 }}>
        {userPrompts?.length ?
            <Box
                sx={{
                    flex: 1, width: "100%", overflow: "auto", alignSelf: "center"
                }}
                className="noScrollbar"
                id="generatedWorkflow"
            >
                {userPrompts.map((userPrompt, index) => {
                    return (
                        <Box key={index}
                            sx={{
                                padding: 2, display: "flex", flexDirection: "column", fontSize: 12
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "flex-end", maxWidth: "60%", alignSelf: "flex-end", gap: "8px", marginBottom: "10px" }}>
                                <Box className="workflowMessage workflowMessageRight">{userPrompt}</Box>
                                <AccountCircle fontSize="large" color="primary" />
                            </Box>
                            <Box sx={{ display: "flex", maxWidth: "60%", alignSelf: "flex-start", alignItems: "flex-end", gap: "8px" }}>
                                <Box className="workflowNanonetsIcon">
                                    <NanonetsIcon />
                                </Box>
                                <Box>
                                    {isGeneratingWorkflow && index === (userPrompts.length - 1) ?
                                        <Box className="workflowMessage workflowMessageLeft">
                                            <CircularProgress color="primary" size={15} />
                                            Generating workflow
                                        </Box>
                                    : generatedWorkflow?.length || index !== (userPrompts.length - 1) ?
                                        <>
                                            <Box className="workflowMessage workflowMessageLeft">
                                                Workflow generated based on your prompt.
                                            </Box>
                                            <Box className="workflowMessage workflowMessageLeft">
                                                Running a demo workflow now...
                                            </Box>
                                            {hasDemoRun[index] ?
                                                <Box className="workflowMessage workflowMessageLeft">
                                                    Demo workflow ran successfully!
                                                </Box>
                                                : null
                                            }
                                        </>
                                    : null
                                    }
                                </Box>
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        : null }
        <Tooltip title={!hasDemoRun[userPrompts.length - 1] ? "Running workflow demo...please wait" : ""} arrow>
            <TextField
                placeholder='What do you want to automate today?'
                variant='standard'
                value={currentInput}
                disabled={!hasDemoRun[userPrompts.length - 1]}
                onChange={(e) => {
                    setCurrentInput(e.target.value);
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setUserInput([...userInput, currentInput]); // Update the userInput state
                        fetchAPI(currentInput); // Call fetchAPI with the current input
                    }
                }}                
                InputProps={{ disableUnderline: true }}
                inputProps={{
                    style: { fontSize: 12 }
                }}
                sx={{
                    borderTop: "1px solid #D6D8E0", background: "#fff", padding: "8px 16px", color: "#7E86A0"
                }}
            />
        </Tooltip>
    </Box>
}

export default WorkflowMainScreen;